import { COLOR_SUCCESS, COLOR_TINT, COLOR_WARNING, DEFAULT_SCHOOL_SUBJECT_COLOR } from '@/constants';

export interface ISubjectSoftColorPresentation {
  backgroundClass: string;
  foregroundClass: string;
}

const SUBJECT_SOFT_COLOR_PRESENTATIONS: Record<string, ISubjectSoftColorPresentation> = {
  [COLOR_TINT]: {
    backgroundClass: 'bg-highlight',
    foregroundClass: 'text-tint',
  },
  [DEFAULT_SCHOOL_SUBJECT_COLOR]: {
    backgroundClass: 'bg-surface-note',
    foregroundClass: 'text-note-accent',
  },
  [COLOR_WARNING]: {
    backgroundClass: 'bg-surface-warning-subtle',
    foregroundClass: 'text-warning-accent',
  },
  [COLOR_SUCCESS]: {
    backgroundClass: 'bg-surface-subject-moss',
    foregroundClass: 'text-subject-moss-accent',
  },
};

export interface IRgbColor {
  r: number;
  g: number;
  b: number;
}

/** Channels of a `#RRGGBB` color */
export const hexToRgb = (hex: string): IRgbColor => ({
  r: parseInt(hex.slice(1, 3), 16),
  g: parseInt(hex.slice(3, 5), 16),
  b: parseInt(hex.slice(5, 7), 16),
});

export const hexToRgba = (hex: string, opacity: number): string => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const getSubjectSoftColor = (color: string): string => hexToRgba(color, 0.15);

export const getSubjectTintStyle = (color: string | undefined): Record<string, string> | undefined =>
  color ? { backgroundColor: getSubjectSoftColor(color), color } : undefined;

export const getSubjectSoftColorPresentation = (
  color: string | null | undefined,
): ISubjectSoftColorPresentation | undefined =>
  color ? SUBJECT_SOFT_COLOR_PRESENTATIONS[color.toUpperCase()] : undefined;
